/**
 * Generated by orval from the Collective Payroll API contract. Do not edit manually.
 */

/**
 * * `not_started` - not_started
 * * `requested` - requested
 * * `received` - received
 * * `not_applicable` - not_applicable
 */
export type W9StatusEnum = (typeof W9StatusEnum)[keyof typeof W9StatusEnum];

export const W9StatusEnum = {
    not_started: 'not_started',
    requested: 'requested',
    received: 'received',
    not_applicable: 'not_applicable',
} as const;
